module.exports = __webpack_public_path__ + "908e4d2e/img/mini-logo.18817ee5.svg";